import React, { useEffect } from "react";
import SharedDiv from "../../../Components/SharedDiv/SharedDiv";
import TextAreaAHSF from "../../../Components/TextAreaAHSF";
import AttachmentASFH from "../../../Components/AttachmentsAHSF";

function AboutProject(props) {
  const defualtValue = props.ReportRow?.agreementAttachment;
  useEffect(() => {
    if (!props.disabled) {
      props?.setOverallProjectObjective(
        props.ReportRow?.overallProjectObjective
      );
      props?.setExpectedProjectDeliverables(
        props.ReportRow?.expectedProjectDeliverables
      );
      props?.setAgreementAttachment(props?.ReportRow?.agreementAttachment)
    }
  }, []);
console.log(props.ReportRow?.expectedProjectDeliverables, "ssssdwdwdssdwdwd");

  return (
    <>
      <SharedDiv
        showTitle={true}
        titleName=""
        child={[
          <div className="form-grid" key="info-grid">
            <TextAreaAHSF
              fieldsName="GeneralProjectGoal"
              show={true}
              disabled={props.disabled}
              onChange={(e) => {
                props?.setOverallProjectObjective(e.target.value);
              }}
              defaultValue={props.ReportRow?.overallProjectObjective}
            />
            <TextAreaAHSF
              fieldsName="TheExpectedOutputFromTheProject"
              show={true}
              disabled={props.disabled}
              onChange={(e) => {
                props?.setExpectedProjectDeliverables(e.target.value);
              }}
              defaultValue={props.ReportRow?.expectedProjectDeliverables}
            />
            <div style={{ marginTop: "45px" }}></div>
            <AttachmentASFH
              id={"AgreementAttachment"}
              textEdit={"انقر لتعديل مرفق الاتفاقية "}
              text={"تحميل مرفق الاتفاقية"}
              title={"إضافة "}
              show={
                props.ReportRow?.agreementAttachment ||
                !window.location.href.includes("report")
                  ? false
                  : true
              }
              disabled={props.disabled}
              clear={false}
              AttachementType="AgreementAttachment"
              singleFile={props.ReportRow?.agreementAttachment}
              readOnly={false}
              onChange={(e) => {
                props?.setAgreementAttachment(e.target.files[0]);
              }}
              showValidationMessage={false}
              validationMessage="يرجى تعبئة هذا الحقل"
            />
          </div>,
        ]}
      />
    </>
  );
}

export default AboutProject;
